// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"166bcc05","239":"992c5b91","455":"f04c7e3e"}[chunkId] + ".chunk.js";
};